module.exports = __webpack_public_path__ + "static/chat-item-icon.d77ca6db.svg";